var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('div',[_c('v-switch',{staticClass:"ma-0",attrs:{"readonly":true,"inset":"","hide-details":"","input-value":"true","color":"#3BCA79","dense":""}})],1):_c('div',[_c('v-switch',{staticClass:"rotate ma-0",attrs:{"readonly":true,"hide-details":"","input-value":"true","inset":"","color":"#F56060","dense":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }